<template>
  <b-overlay
    :opacity="0.5"
    :show="loading"
    rounded="sm"
    :blur="'true'"
  >
    <b-card>
      <ValidationObserver
        ref="createStaffForm"
        v-slot="{ handleSubmit }"
        slim
      >
        <b-form
          @submit.prevent="handleSubmit(onClickCreateOrder)"
        >
          <b-row>
            <!-- Business Profile -->
            <b-col
              cols="12"
              md="5"
              class="mt-2 ml-md-1"
            >
              <b-form-group
                label="Business Profile*"
                label-cols-lg="4"
                label-for="h-merchantBusiness"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-merchantBusiness"
                  vid="h-c-merchantBusiness"
                  rules="required"
                >
                  <v-select
                    v-model="merchant_business_id"
                    :options="businesses"
                    :reduce="option => option.id"
                    label="business_name"
                    placeholder="Select Business profile"
                    autocomplete="off"
                    @input="handleBusinessProfileChange"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="mt-2 mb-2 ml-md-1 font-weight-bolder">
            Package Details
          </div>
          <b-row class="">

            <!-- Waybill No -->
            <b-col
              cols="12"
              md="5"
              class="ml-md-1 mr-lg-4"
            >
              <b-form-group
                label="Waybill No"
                label-cols-lg="4"
                label-for="h-waybillNo"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-waybillNo"
                  vid="h-c-waybillNo"
                  :rules="is_waybill_auto ? '' : 'required'"
                >
                  <b-form-input
                    id="waybillNo"
                    v-model="form.waybill_number"
                    :placeholder="waybillPlaceholder(is_waybill_auto)"
                    :disabled="is_waybill_auto == true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Order No"
                label-cols-lg="4"
                label-for="h-orderNo"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-orderNo"
                  vid="h-c-orderNo"
                >
                  <b-form-input
                    id="orderNo"
                    v-model="form.order_no"
                    placeholder="001"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- COD Amount -->
            <b-col
              cols="12"
              md="5"
              class="ml-md-1 mr-lg-4"
            >

              <b-form-group
                label="COD Amount*"
                label-cols-lg="4"
                label-for="cod"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-cod"
                  vid="h-c-cod"
                  rules="required"
                >
                  <b-form-input
                    id="cod"
                    v-model="form.cod"
                    type="number"
                    placeholder="Item value + Delivery Charge"
                    step=".01"
                    pattern="^\d*(\.\d{0,2})?$"
                    :maxlength="maxCodLength"
                    no-wheel
                    @input="enforceCodMaxLength"
                    @keydown.up.prevent
                    @keydown.down.prevent
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <!-- Weight -->
              <b-form-group
                label="Weight*"
                label-cols-lg="4"
                label-for="weight"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-weight"
                  vid="h-c-weight"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="weight"
                      ref="weightInput"
                      v-model="form.weight"
                      type="number"
                      placeholder="1"
                      autocomplete="off"
                      step=".01"
                      pattern="^\d*(\.\d{0,2})?$"
                      no-wheel
                      @input="checkWeightRange"
                      @keydown.up.prevent
                      @keydown.down.prevent
                    />
                    <b-input-group-append is-text>
                      <b>Kg</b>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="mt-2 mb-2 ml-md-1 font-weight-bolder">
            Customer Details
          </div>
          <b-row>
            <!-- Customer Name -->
            <b-col
              cols="12"
              md="5"
              class="ml-md-1 mr-lg-4"
            >
              <b-form-group
                label="Customer Name*"
                label-cols-lg="4"
                label-for="customerName"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-customerName"
                  vid="h-c-customerName"
                  rules="required"
                >
                  <b-form-input
                    id="customerName"
                    v-model="form.customer_name"
                    placeholder="Alex"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <!-- Address -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Address*"
                label-cols-lg="4"
                label-for="address"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-address"
                  vid="h-c-address"
                  rules="required"
                >
                  <b-form-input
                    id="address"
                    v-model="form.customer_address"
                    placeholder="Colombo 07"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>

          </b-row>

          <!-- Phone No -->
          <b-row>
            <b-col
              cols="12"
              md="5"
              class="ml-md-1 mr-lg-4"
            >
              <b-form-group
                label="Primary Phone No*"
                label-cols-lg="4"
                label-for="customerPhone"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-customerPhone"
                  vid="h-c-customerPhone"
                  rules="required"
                >
                  <b-form-input
                    id="customerPhone"
                    v-model="form.customer_phone"
                    type="number"
                    placeholder="0xxxxxxxxx"
                    autocomplete="off"
                    no-wheel
                    @keydown.up.prevent
                    @keydown.down.prevent
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <!-- Email -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Email"
                label-cols-lg="4"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="form.customer_email"
                  type="email"
                  placeholder="abc@parallax.lk"
                  autocomplete="off"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!--second Phone No -->
            <b-col
              v-if="orderSettings.second_phone_number"
              cols="12"
              md="5"
              class="ml-md-1 mr-lg-4"
            >
              <b-form-group
                label="Second Phone No"
                label-cols-lg="4"
                label-for="secondPhoneNumber"
              >
                <b-form-input
                  id="secondPhoneNumber"
                  v-model="form.customer_secondary_phone"
                  type="number"
                  placeholder="0xxxxxxxxx"
                  autocomplete="off"
                  no-wheel
                  @keydown.up.prevent
                  @keydown.down.prevent
                />
              </b-form-group>
            </b-col>
          </b-row>
          <div class="mt-2 mb-2 ml-md-1 font-weight-bolder">
            {{ !orderSettings.origin_city_freeze ? 'Origin & Destination' : 'Destination' }}
          </div>
          <b-row>
            <!-- Pickup address -->
            <b-col
              v-if="!orderSettings.origin_city_freeze"
              cols="12"
              md="5"
              class="ml-md-1 mr-lg-4"
            >
              <b-form-group
                label="Pickup Address*"
                label-cols-lg="4"
                label-for="pickupAddress"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="pickupAddress"
                  rules="required"
                >
                  <v-select
                    v-model="form.pickup_address"
                    class="pickup"
                    :options="businessAddresses"
                    :reduce="option => option.id"
                    label="pickup_address"
                    autocomplete="off"
                    placeholder="Select Pickup Address"
                    @input="setDefaultOriginCity()"
                  >
                    <template v-slot:option="option">
                      {{ option.pickup_address }}
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
            <!-- Destination City -->
            <b-col
              :cols="orderSettings.origin_city_freeze ? '12': '12'"
              :md="orderSettings.origin_city_freeze ? '5': '6'"
              :class="orderSettings.origin_city_freeze ? 'ml-md-1 mr-lg-4': ''"
            >
              <!-- Destination City -->
              <b-form-group
                label="Destination City*"
                label-cols-lg="4"
                label-for="city"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-city"
                  vid="h-c-city"
                  rules="required"
                >
                  <v-select
                    v-model="form.destination_city_id"
                    :options="cityOptions"
                    :reduce="option => option.id"
                    label="name"
                    placeholder="Select City"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <!-- Origin City -->
            <b-col
              v-if="!orderSettings.origin_city_freeze"
              cols="12"
              md="5"
              class="ml-md-1 mr-lg-4"
            >
              <b-form-group
                label=" Origin City*"
                label-cols-lg="4"
                label-for="h-originCity"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-originCity"
                  vid="h-c-originCity"
                  rules="required"
                >
                  <b-form-input
                    v-model="origin_city_id"
                    :hidden="true"
                  />
                  <b-form-input
                    v-model="origin_city_name"
                    :disabled="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="mt-2 mb-2 ml-md-1 font-weight-bolder">
            Other Details
          </div>
          <b-row class="mb-1">
            <!-- Order Description -->
            <b-col
              cols="12"
              md="5"
              class="ml-md-1 mr-lg-4"
            >
              <b-form-group
                label="Order Description"
                label-cols-lg="4"
                label-for="description"
              >
                <ValidationProvider
                  name="h-c-description"
                  vid="h-c-description"
                  rules=""
                >
                  <b-form-textarea
                    id="description"
                    v-model="form.description"
                    placeholder="Description"
                    :class="form.description.length >= maxChar ? 'text-danger' : ''"
                    :maxlength="maxChar"
                  />
                  <small
                    class="textarea-counter-value float-right"
                    :class="form.description.length >= maxChar ? 'bg-danger' : ''"
                  >
                    <span class="char-count">{{ form.description.length }}</span> / {{ maxChar }}
                  </small>
                </ValidationProvider>
              </b-form-group>
            </b-col>

            <!-- Remarks -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Remarks"
                label-cols-lg="4"
                label-for="remark"
              >
                <ValidationProvider
                  name="h-c-remark"
                  vid="h-c-remark"
                  rules=""
                >
                  <b-form-textarea
                    id="remark"
                    v-model="form.remark"
                    placeholder="Extra Details"
                    :class="form.remark.length >= maxChar ? 'text-danger' : ''"
                    :maxlength="maxChar"
                  />
                  <small
                    class="textarea-counter-value float-right"
                    :class="form.remark.length >= maxChar ? 'bg-danger' : ''"
                  >
                    <span class="char-count">{{ form.remark.length }}</span> / {{ maxChar }}
                  </small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex flex-wrap justify-content-start justify-content-md-end mb-1 mr-md-2 mr-xl-1">
            <b-button
              type="button"
              variant="outline-secondary"
              class="mr-1"
              @click="handleReUpload"
            >
              Re-Upload
            </b-button>
            <b-button
              type="reset"
              variant="outline-secondary"
              class="mr-1"
            >Reset</b-button>
            <b-button
              class="mr-1 mt-1 mt-md-0 custom-button-color"
              type="submit"
            >Submit</b-button>
          </div>
        </b-form>
      </ValidationObserver>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BFormTextarea, BRow, BCol, BButton, BCard, BOverlay, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const ResourceRepository = RepositoryFactory.get('resource')
const OrderRepository = RepositoryFactory.get('order')
const MerchantRepository = RepositoryFactory.get('merchant')

export default {
  name: 'SingleOrderCreate',
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BRow,
    BCol,
    BButton,
    BCard,
    BOverlay,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
  },
  mixins: [SuccessMessage, ErrorMessage],
  props: {
    orderSettings: {
      type: Object,
      default: null,
    },
    waybillPlaceholder: {
      type: Function,
      default: () => {},
    },
    waybillPattern: {
      type: Function,
      default: () => {},
    },
    patternTitle: {
      type: Function,
      default: () => {},
    },
    prefill: { type: Object, default: null },
  },
  data() {
    return {
      businesses: [],
      businessAddresses: [],
      cityOptions: [],
      is_waybill_auto: true,
      merchant_business_id: '',
      loading: false,
      concat: true,
      origin_city_id: '',
      form: {
        order_no: '',
        customer_name: '',
        customer_address: '',
        customer_phone: '',
        customer_secondary_phone: '',
        customer_email: '',
        destination_city_id: '',
        cod: '',
        weight: '',
        description: '',
        remark: '',
      },
      search: '',
      pickupAddress: '',
      defaultPickAddressId: '',
      typingtimer: null,
      isMaxWeight: false,
      validationState: null,
      validationMessage: '',
      maxChar: 190,
      pendingPrefillDestinationCityName: '',
      isInitialized: false,
    }
  },
  computed: {
    maxCodLength() {
      if (this.orderSettings.cod_range_setting && this.orderSettings.cod_range_setting.enabled && this.orderSettings.cod_range_setting.max_cod_amount) {
        // Integer digits + decimal point + 2 cents digits
        return Math.floor(Number(this.orderSettings.cod_range_setting.max_cod_amount)).toString().length + 3
      }
      return null
    },
  },
  watch: {
    prefill: {
      async handler(newVal) { // Make the handler async
        try {
          if (newVal && typeof newVal === 'object' && this.isInitialized) {
            this.loading = true
            await this.applyPrefillLogic(newVal) // We'll create this new method
            this.loading = false
          }
        } catch (e) {
          this.convertAndNotifyError(e)
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.loading = true
    await this.getMerchantBusinessSettingsDetails()
    await this.getCityList()
    await this.getBusinessList()
    this.isInitialized = true
    if (this.prefill) {
      await this.applyPrefillLogic(this.prefill)
    }
    this.loading = false
  },
  methods: {
    handleReUpload() {
      this.$emit('re-upload')
    },
    async getMerchantBusinessSettingsDetails() {
      try {
        const data = localStorage.getItem('merchant_business_setting') ? JSON.parse(localStorage.getItem('merchant_business_setting')) : (await MerchantRepository.getMerchantBusinessSettingsDetails()).data.data
        if (!localStorage.getItem('merchant_business_setting')) localStorage.setItem('merchant_business_setting', JSON.stringify(data))
        this.is_waybill_auto = data.is_waybill_auto
        this.$emit('set-placeholder')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    checkWeightRange() {
      const minWeight = this.orderSettings.weight_range_setting.min_weight
      const maxWeight = this.orderSettings.weight_range_setting.max_weight
      const currentWeight = parseFloat(this.form.weight)
      if (this.orderSettings.weight_range_setting.enabled === true && (currentWeight < minWeight || currentWeight > maxWeight)) {
        this.validationState = false
        this.validationMessage = `The order weight should be between ${minWeight} Kg to ${maxWeight} Kg`
        this.isMaxWeight = true
      } else {
        this.validationState = true
        this.validationMessage = ''
        this.isMaxWeight = false
      }
      this.$refs.weightInput.setCustomValidity(this.validationMessage)
    },
    async getBusinessList() {
      try {
        this.loading = true
        const { data } = (await ResourceRepository.getBusinessList()).data
        this.businesses = data
        if (this.businesses.length === 1) {
          this.merchant_business_id = this.businesses[0].id
          await this.getAddress()
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async getAddress() {
      this.loading = true
      try {
        this.form.pickup_address = null
        this.businessAddresses = (await MerchantRepository.getbusinessAddresses(this.merchant_business_id, this.concat)).data.data
        localStorage.setItem('address', JSON.stringify(this.businessAddresses))
        this.defaultPickAddressId = (this.businessAddresses.filter(address => address.is_default))[0].id
        if (this.defaultPickAddressId) {
          this.form.pickup_address = this.defaultPickAddressId
          await this.setDefaultOriginCity()
        }
        // const { data } = (await MerchantRepository.getMerchantBusinessDetails(this.merchant_business_id)).data
        // await this.getCityList(data.default_address.city.name || '')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    handleBusinessProfileChange() {
      if (!this.orderSettings.origin_city_freeze) {
        this.getAddress()
      }
    },
    enforceCodMaxLength() {
      const maxLength = this.maxCodLength
      if (maxLength && this.form.cod && this.form.cod.toString().length > maxLength) {
        this.form.cod = this.form.cod.toString().slice(0, maxLength)
      }
    },
    async setDefaultOriginCity() {
      try {
        this.loading = true
        const cities = JSON.parse(localStorage.getItem('address'))
        // Loop through the array and check for a matching city id
        let cityId = null
        let cityName = null
        cities.forEach(city => {
          if (city.id === this.form.pickup_address) {
            cityId = city.city_id
            cityName = city.city_name
          }
        })
        if (cityId) {
          this.origin_city_id = cityId
          this.origin_city_name = cityName
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async getCityList() {
      try {
        this.cityOptions = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityListDropdownList()).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(this.cityOptions))
        this.applyPendingDestinationCity()
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async applyPrefillLogic(prefillData) {
      try {
      // This contains the logic that was previously in your watcher
        const allowedKeys = [
          'order_no', 'customer_name', 'customer_address',
          'customer_phone', 'customer_secondary_phone', 'customer_email',
          'cod', 'weight', 'description', 'remark',
        ]
        allowedKeys.forEach(key => {
          if (Object.prototype.hasOwnProperty.call(prefillData, key) && prefillData[key]) {
            this.form[key] = prefillData[key]
          }
        })

        if (prefillData.merchant_business) {
          await this.mapMerchantBusinessByName(prefillData.merchant_business)
          if (prefillData.pickup_address) {
            this.mapPickupAddressByName(prefillData.pickup_address)
          }
        }

        if (
          !this.is_waybill_auto
        && prefillData.waybill_number
        ) {
          this.$set(this.form, 'waybill_number', prefillData.waybill_number)
        }

        if (prefillData.destination_city) {
          const mapped = this.mapDestinationCityNameToId(prefillData.destination_city)
          if (!mapped) {
            this.pendingPrefillDestinationCityName = prefillData.destination_city
          }
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    mapDestinationCityNameToId(name) {
      if (!name || !Array.isArray(this.cityOptions) || !this.cityOptions.length) return false
      const match = this.cityOptions.find(
        c => (c.name || '').toLowerCase().trim() === String(name).toLowerCase().trim(),
      )
      if (match) {
        this.$set(this.form, 'destination_city_id', match.id)
        return true
      }
      return false
    },
    applyPendingDestinationCity() {
      if (this.pendingPrefillDestinationCityName) {
        const ok = this.mapDestinationCityNameToId(this.pendingPrefillDestinationCityName)
        if (ok) this.pendingPrefillDestinationCityName = ''
      }
    },
    async mapMerchantBusinessByName(name) {
      if (!name || !Array.isArray(this.businesses) || this.businesses.length === 0) return false
      const needle = String(name).toLowerCase().replace(/[^a-z]/g, '')

      // 2. Find a match by applying the EXACT SAME normalization to the business names in the list.
      const match = this.businesses.find(business => {
        const businessName = business.business_name || ''
        const normalizedBusinessName = businessName.toLowerCase().replace(/[^a-z]/g, '')

        return normalizedBusinessName === needle
      })
      if (!match) return false

      this.$set(this, 'merchant_business_id', match.id)

      if (!this.orderSettings.origin_city_freeze) {
      // keep your existing flow to set pickup/origin
        await this.getAddress()
      }
      return true
    },
    mapPickupAddressByName(name) {
      if (!name || !Array.isArray(this.businessAddresses) || this.businessAddresses.length === 0) {
        return false
      }

      // Use a simple trim and lowercase for robust matching
      const needle = String(name).toLowerCase().trim()
      const match = this.businessAddresses.find(
        addr => (addr.pickup_address || '').toLowerCase().trim() === needle,
      )

      if (match) {
        this.form.pickup_address = match.id
        // IMPORTANT: We must also trigger the origin city update,
        // just like the @input handler on the dropdown does.
        this.setDefaultOriginCity()
        return true
      }

      return false
    },
    async onClickCreateOrder() {
      this.loading = true
      const payload = {
        general_data: {
          merchant_business_id: this.merchant_business_id,
          origin_city_id: this.origin_city_id,
          pickup_address_id: this.form.pickup_address,
        },
        order_data: [],
      }
      payload.order_data.push({
        waybill_number: this.form.waybill_number,
        order_no: this.form.order_no,
        customer_name: this.form.customer_name,
        customer_address: this.form.customer_address,
        customer_phone: this.form.customer_phone,
        customer_secondary_phone: this.form.customer_secondary_phone,
        customer_email: this.form.customer_email,
        destination_city_id: this.form.destination_city_id,
        cod: this.form.cod,
        weight: this.form.weight,
        description: this.form.description,
        remark: this.form.remark || null,
      })
      if (!payload.general_data.origin_city_id) delete payload.general_data.origin_city_id
      try {
        const { data } = (await OrderRepository.createSingleOrder(payload)).data
        this.showSuccessMessage('Order created successfully')
        sessionStorage.setItem('newlyAddedWaybills', data.toString())
        await this.$router.replace('/all-orders')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
@import '../../../@core/scss/button-color.scss';
</style>
